import { useMemo, useState } from 'react';
import { computeBookingPrice } from '../constants/bookingFare';

export function useBookingPrice({
  baseAmount,
  totalAmount,
  travelerLabel,
  serviceLabel,
  isFlight,
  currency = 'USD',
}) {
  const [tierId, setTierId] = useState('basic');
  const [webCheckIn, setWebCheckIn] = useState('no');
  const [cancellationProtection, setCancellationProtection] = useState('no');

  const pricing = useMemo(
    () =>
      computeBookingPrice({
        baseAmount,
        totalAmount,
        travelerLabel,
        serviceLabel,
        tierId,
        webCheckIn: webCheckIn === true || webCheckIn === 'yes',
        cancellationProtection:
          cancellationProtection === true || cancellationProtection === 'yes',
        isFlight,
        currency,
      }),
    [
      baseAmount,
      totalAmount,
      travelerLabel,
      serviceLabel,
      tierId,
      webCheckIn,
      cancellationProtection,
      isFlight,
      currency,
    ]
  );

  return {
    tierId,
    setTierId,
    webCheckIn,
    setWebCheckIn,
    cancellationProtection,
    setCancellationProtection,
    pricing,
  };
}
